import { useEffect, useState } from 'react';
import { NavigationManager } from 'src/_shared/managers/navigation.manager';
import { TranslatorManager } from 'src/_shared/managers/TranslatorManager';
import { RouteEnum } from 'src/_shared/routes';
import '../styles/linksList.style.scss';

export interface ILinksListProps {
    isIDEOpen: boolean;
    route: string;
}

interface NavItem {
    label: string;
    icon: string;
    route: string;
    match: (current: string) => boolean;
}

const navItems: NavItem[] = [
    {
        label: 'Home',
        icon: 'bi-house-fill',
        route: RouteEnum.home,
        match: current => current.includes(RouteEnum.home),
    },
    {
        label: 'Clienti',
        icon: 'bi-people-fill',
        route: RouteEnum.customers,
        match: current => current.includes(RouteEnum.customers),
    },
    {
        label: 'Esercizi',
        icon: 'bi-activity',
        route: RouteEnum.exercises,
        match: current => current.includes(RouteEnum.exercises),
    },
    {
        label: 'Vendite (Beta)',
        icon: 'bi-cart-fill',
        route: RouteEnum.sales,
        match: current => current.includes(RouteEnum.sales),
    },
];

const LinkList: React.FC<ILinksListProps> = ({ isIDEOpen, route }) => {
    const translator = TranslatorManager.getInstance();
    const navigator = NavigationManager.getInstance();
    const [currentRoute, setCurrentRoute] = useState<string>(NavigationManager.getInstance().getCurrentRoute());

    const handleRouteChange = (path: any) => {
        navigator.navigateTo(path);
        setCurrentRoute(path);
    };

    useEffect(() => {
        setCurrentRoute(navigator.getCurrentRoute());
    }, [route, navigator]);

    return (
        <nav className='sidebar-nav'>
            <div className='nav-section-label'>Menu</div>
            {navItems.map(item => {
                const isActive = item.match(navigator.getCurrentRoute());
                return (
                    <div key={item.route} className={`nav-link-item ${isActive ? 'nav-link-item--active' : ''}`} onClick={() => handleRouteChange(item.route)}>
                        <div className={`nav-link-icon ${isActive ? 'nav-link-icon--active' : ''}`}>
                            <i className={`bi ${item.icon}`}></i>
                        </div>
                        <span className='nav-link-label'>{item.label}</span>
                        {isActive && <div className='nav-link-indicator' />}
                    </div>
                );
            })}
        </nav>
    );
};

export default LinkList;
